/* LESHEM'S — Smart Filter & Search (Globo) integration.
   The Dune/legacy filter remains untouched as a fallback.
   It is hidden only when Globo has rendered a real filter tree for the page. */
(function () {
  'use strict';

  var BODY_CLASS = 'leshems-globo-active';
  var MOUNT_ID = 'LeshemsGloboFilterMount';
  var MOBILE_MEDIA = '(max-width: 767px)';
  var observer;
  var productStateCache = Object.create(null);

  function getCommerceConfig() {
    var mount = document.getElementById(MOUNT_ID);
    return {
      mode: mount ? (mount.getAttribute('data-commerce-mode') || '') : '',
      quoteLabel: mount ? (mount.getAttribute('data-quote-label') || 'Price available upon request') : 'Price available upon request'
    };
  }

  function primeCommerceStateCache(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var products = scope.querySelectorAll('[data-product-handle][data-leshems-commerce-state]');

    products.forEach(function (product) {
      var handle = (product.getAttribute('data-product-handle') || '').trim().toLowerCase();
      var state = product.getAttribute('data-leshems-commerce-state');

      if (!handle) return;
      if (state !== 'direct_purchase' && state !== 'quote_only') return;
      productStateCache[handle] = Promise.resolve(state);
    });
  }

  function getProductHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var match = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function ensureQuoteLabel(card, quoteLabel) {
    var quote = card.querySelector('.leshems-globo-quote-price');
    if (quote) {
      if (quote.textContent !== quoteLabel) quote.textContent = quoteLabel;
      return quote;
    }

    var priceWrapper = card.querySelector('.spf-product-card__price-wrapper');
    quote = document.createElement('div');
    quote.className = 'leshems-globo-quote-price';
    quote.textContent = quoteLabel;

    if (priceWrapper && priceWrapper.parentNode) {
      priceWrapper.parentNode.insertBefore(quote, priceWrapper);
    } else {
      var content = card.querySelector('.spf-product-card__content, .spf-product-card__details, .spf-product-card__title');
      if (content) {
        if (content.classList.contains('spf-product-card__title') && content.parentNode) {
          content.parentNode.insertBefore(quote, content.nextSibling);
        } else {
          content.appendChild(quote);
        }
      }
    }

    return quote;
  }

  function setCardCommerceState(card, handle, state, quoteLabel) {
    if (card.getAttribute('data-leshems-commerce-handle') !== handle) return;

    var quote = card.querySelector('.leshems-globo-quote-price');
    var currentState = card.getAttribute('data-leshems-commerce-state');

    if (state === 'direct_purchase') {
      if (currentState === 'direct_purchase'
        && card.classList.contains('leshems-globo-direct-card')
        && !card.classList.contains('leshems-globo-quote-card')
        && !quote
      ) return;

      card.classList.remove('leshems-globo-quote-card');
      card.classList.add('leshems-globo-direct-card');
      card.setAttribute('data-leshems-commerce-state', 'direct_purchase');
      if (quote && quote.parentNode) quote.parentNode.removeChild(quote);
      return;
    }

    if (currentState === 'quote_only'
      && card.classList.contains('leshems-globo-quote-card')
      && !card.classList.contains('leshems-globo-direct-card')
      && quote
      && quote.textContent === quoteLabel
    ) return;

    card.classList.remove('leshems-globo-direct-card');
    card.classList.add('leshems-globo-quote-card');
    card.setAttribute('data-leshems-commerce-state', 'quote_only');
    ensureQuoteLabel(card, quoteLabel);
  }

  function loadProductCommerceState(handle) {
    if (productStateCache[handle]) return productStateCache[handle];

    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    routeRoot = routeRoot.replace(/\/?$/, '/');

    productStateCache[handle] = window.fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product commerce lookup failed');
        return response.json();
      })
      .then(function (product) {
        var tags = (product.tags || []).map(function (tag) {
          return String(tag).trim().toLowerCase();
        });
        var hasDirectTag = tags.indexOf('direct purchase') !== -1
          || tags.indexOf('leshem_direct_purchase') !== -1;
        var hasBlockingTag = tags.indexOf('noprice') !== -1
          || tags.indexOf('leshem_mto_quote') !== -1;
        var hasVerifiedPrice = Number(product.price) > 0;

        return hasDirectTag && !hasBlockingTag && hasVerifiedPrice
          ? 'direct_purchase'
          : 'quote_only';
      })
      .catch(function () {
        return 'quote_only';
      });

    return productStateCache[handle];
  }

  function applyCommerceStateToCards(root) {
    var config = getCommerceConfig();
    if (config.mode !== 'quote-default') return;

    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.spf-product-card');

    cards.forEach(function (card) {
      var handle = getProductHandle(card);
      if (!handle) {
        if (card.getAttribute('data-leshems-commerce-handle') !== '') {
          card.setAttribute('data-leshems-commerce-handle', '');
          card.removeAttribute('data-leshems-commerce-state');
        }
        if (!card.getAttribute('data-leshems-commerce-state')) {
          setCardCommerceState(card, '', 'quote_only', config.quoteLabel);
        }
        return;
      }

      if (card.getAttribute('data-leshems-commerce-handle') !== handle) {
        card.setAttribute('data-leshems-commerce-handle', handle);
        card.removeAttribute('data-leshems-commerce-state');
      }
      if (!card.getAttribute('data-leshems-commerce-state')) {
        setCardCommerceState(card, handle, 'quote_only', config.quoteLabel);
      }

      loadProductCommerceState(handle).then(function (state) {
        setCardCommerceState(card, handle, state, config.quoteLabel);
      });
    });
  }

  function isLooseCollection() {
    var match = window.location.pathname.match(/^\/collections\/([^\/?#]+)/i);
    if (!match) return false;
    return match[1].toLowerCase().indexOf('loose') !== -1;
  }

  function isCatalogProductSearchInput(input) {
    if (!input) return false;
    if (input.classList && input.classList.contains('gf-controls-search-input')) return true;
    var label = [
      input.getAttribute('placeholder') || '',
      input.getAttribute('aria-label') || ''
    ].join(' ').toLowerCase();
    return label.indexOf('search product') !== -1;
  }

  function getCatalogSearchWrapper(input) {
    var boundary = input.closest('#gf-controls-container') || input.closest('#gf-tree');
    var direct = input.closest('.gf-controls-search, .gf-controls-search-form, .gf-search, .gf-search-wrapper');
    if (direct && direct !== boundary) return direct;

    var candidate = input.parentElement || input;
    var node = candidate;
    var depth = 0;

    while (node && node.parentElement && node.parentElement !== boundary && depth < 5) {
      var parent = node.parentElement;
      if (parent.querySelector('select, .gf-refine-toggle-mobile, .gf-option-block, .gf-filter-heading')) break;
      if (parent.querySelectorAll('input').length > 1) break;
      candidate = parent;
      node = parent;
      depth += 1;
    }

    return candidate === boundary ? input.parentElement : candidate;
  }

  function setSearchWrapperVisibility(wrapper, show) {
    if (!wrapper) return;
    if (show) {
      if (wrapper.getAttribute('data-leshems-catalog-search-hidden') === 'true') {
        wrapper.removeAttribute('data-leshems-catalog-search-hidden');
        wrapper.style.removeProperty('display');
        wrapper.style.removeProperty('margin');
        wrapper.style.removeProperty('padding');
        wrapper.style.removeProperty('height');
        wrapper.style.removeProperty('min-height');
      }
    } else {
      wrapper.setAttribute('data-leshems-catalog-search-hidden', 'true');
      wrapper.style.setProperty('display', 'none', 'important');
      wrapper.style.setProperty('margin', '0', 'important');
      wrapper.style.setProperty('padding', '0', 'important');
      wrapper.style.setProperty('height', '0', 'important');
      wrapper.style.setProperty('min-height', '0', 'important');
    }
  }

  function applyCatalogSearchPolicy() {
    var mount = document.getElementById(MOUNT_ID);
    if (!mount) return;

    var keepSearch = isLooseCollection();
    var seen = [];
    var inputs = document.querySelectorAll('#gf-tree input, #gf-controls-container input, input.gf-controls-search-input');

    inputs.forEach(function (input) {
      if (!isCatalogProductSearchInput(input)) return;
      var wrapper = getCatalogSearchWrapper(input);
      if (!wrapper || wrapper.id === 'gf-controls-container' || wrapper.id === 'gf-tree') return;
      if (seen.indexOf(wrapper) !== -1) return;
      seen.push(wrapper);
      setSearchWrapperVisibility(wrapper, keepSearch);
    });
  }

  function hasRealFilterContent(tree) {
    if (!tree) return false;
    return !!tree.querySelector('.gf-filter-contents, .gf-option-block, .globo-selected-items-wrapper, .gf-filter-heading');
  }

  function isMobileFilterDrawer() {
    return !!(window.matchMedia && window.matchMedia(MOBILE_MEDIA).matches);
  }

  function getExpectedTreeParent(mount) {
    return isMobileFilterDrawer() ? document.body : mount;
  }

  function placeFilterTree(tree, mount) {
    var expectedParent = getExpectedTreeParent(mount);
    if (expectedParent && tree.parentNode !== expectedParent) {
      expectedParent.appendChild(tree);
    }
    if (!isMobileFilterDrawer()) {
      mount.removeAttribute('hidden');
    }
  }

  function integrateGlobo() {
    var mount = document.getElementById(MOUNT_ID);
    var tree = document.getElementById('gf-tree');

    primeCommerceStateCache(document);

    if (!mount || !hasRealFilterContent(tree)) {
      applyCatalogSearchPolicy();
      return false;
    }

    placeFilterTree(tree, mount);
    document.body.classList.add(BODY_CLASS);
    applyCatalogSearchPolicy();
    applyCommerceStateToCards(document);
    return true;
  }

  function scheduleIntegration() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(integrateGlobo);
    }
    window.setTimeout(integrateGlobo, 80);
    window.setTimeout(integrateGlobo, 350);
    window.setTimeout(integrateGlobo, 900);
  }

  window.addEventListener('globoFilterRenderCompleted', scheduleIntegration);

  document.addEventListener('DOMContentLoaded', function () {
    primeCommerceStateCache(document);
    scheduleIntegration();

    if (window.matchMedia) {
      var mobileMedia = window.matchMedia(MOBILE_MEDIA);
      var handleViewportChange = function () {
        scheduleIntegration();
      };
      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', handleViewportChange);
      } else if (mobileMedia.addListener) {
        mobileMedia.addListener(handleViewportChange);
      }
    }

    observer = new MutationObserver(function () {
      var tree = document.getElementById('gf-tree');
      var mount = document.getElementById(MOUNT_ID);
      if (tree && mount && tree.parentNode !== getExpectedTreeParent(mount)) scheduleIntegration();
      applyCatalogSearchPolicy();
      applyCommerceStateToCards(document);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (observer) observer.disconnect();
    }, 30000);
  });
})();
